import { Rate, Tooltip } from "antd";
import dayjs from "dayjs";
import { formatPhoneNumber, formatAmount } from "../../../../utils/appUtils";

export const CONSULTATION_MONITORING_HEADER_COLUMNS = ({ actionRender, getConsultationDropdown, activeTab }) => [
    {
        title: "SNo",
        width: 60,
        align: "center",
        render: (_, detail, index) => index + 1
    },
    {
        title: "Cons. ID",
        width: 120,
        dataIndex: "consultationNo"
    },
    {
        title: "Customer Name/ID",
        width: 180,
        render: (detail) => {
            const first = detail?.customerResponse?.firstName || "Nil";
            const middle = detail?.customerResponse?.middleName || "";
            const last = detail?.customerResponse?.lastName || "";
            const fullName = `${first} ${middle} ${last}`.trim();
            const isLastLong = last?.length > 10;
            const shortName = isLastLong
                ? `${first} ${middle} ${last?.slice(0, 3)}...`
                : fullName;
            return (
                <>
                    {isLastLong ? (
                        <Tooltip title={fullName}>
                            <p style={{ padding: 0, margin: 0 }}>{shortName}</p>
                        </Tooltip>
                    ) : (
                        <p style={{ padding: 0, margin: 0 }}>{shortName}</p>
                    )}
                    <small style={{ color: "#ABABAB" }}>{detail?.customerResponse?.customerNo || "Nil"}</small>
                </>
            );
        }
    },
    {
        title: "Cust.Contact Details",
        width: 180,
        render: (detail) => {
            return <>
                <p style={{ padding: 0, margin: 0 }}>{detail?.customerResponse?.mobileNumber ? formatPhoneNumber(detail?.customerResponse?.mobileNumber) : "Nil"}</p>
                <small style={{ color: "#ABABAB" }}>{detail?.customerResponse?.email || "Nil"}</small>
            </>
        }
    },
    {
        title: "Advocate Name/ID",
        width: 180,
        render: (detail) => {
            const first = detail?.lawyerResponse?.firstName || "Nil";
            const middle = detail?.lawyerResponse?.middleName || "";
            const last = detail?.lawyerResponse?.lastName || "";
            const fullName = `${first} ${middle} ${last}`.trim();
            const isLastLong = last?.length > 10;
            const shortName = isLastLong
                ? `${first} ${middle} ${last?.slice(0, 3)}...`
                : fullName;
            return (
                <>
                    {isLastLong ? (
                        <Tooltip title={fullName}>
                            <p style={{ padding: 0, margin: 0 }}>{shortName}</p>
                        </Tooltip>
                    ) : (
                        <p style={{ padding: 0, margin: 0 }}>{shortName}</p>
                    )}
                    <small style={{ color: "#ABABAB" }}>{detail?.lawyerResponse?.lawyerNo || "Nil"}</small>
                </>
            );
        }
    },
    {
        title: "Advocate Contact Details",
        width: 180,
        render: (detail) => {
            return <>
                <p style={{ padding: 0, margin: 0 }}>{detail?.lawyerResponse?.mobileNumber ? formatPhoneNumber(detail?.lawyerResponse?.mobileNumber) : "Nil"}</p>
                <small style={{ color: "#ABABAB" }}>{detail?.lawyerResponse?.email || "Nil"}</small>
            </>
        }
    },
    ...(activeTab !== "LOW_RATING" ? [{
        title: "Date",
        width: 100,
        render: (detail) => <>{detail?.consultationDate ? dayjs(detail?.consultationDate).format("DD-MM-YYYY") : "Nil"}</>
    }] : []),
    ...(activeTab === "LOW_RATING" ? [{
        title: "Cons. Date",
        width: 120,
        render: (detail) => <>{detail?.consultationDate ? dayjs(detail?.consultationDate).format("DD MMM YYYY") : "Nil"}</>
    }] : []),
    {
        title: "Cons.Time",
        align: "center",
        dataIndex: "consultationTime",
        width: 80,
        render: (_, detail) => <>{detail?.consultationTime || "Nil"} Min</>
    },
    {
        title: "Start Time",
        width: 100,
        render: (detail) => {
            if (!detail?.consultationStartTime) return "Nil";
            const time = dayjs(detail?.consultationStartTime).format("hh:mm A");
            return <>{time}</>
        }
    },
    {
        title: "End Time",
        width: 100,
        render: (_, detail) => {
            if (!detail?.consultationEndTime) return "Nil";
            const time = dayjs(detail?.consultationEndTime).format("hh:mm A");
            return <>{time}</>
        }
    },
    {
        title: "Specialization",
        width: 150,
        render: (detail) => {
            const specs = detail?.specialization || [];
            const joinedSpecs = specs?.join(", ");
            const displayText =
                specs?.length > 2 ? `${specs?.slice(0, 2)?.join(", ")}...` : joinedSpecs || "Nil";

            return (
                <Tooltip title={joinedSpecs}>
                    <span>{displayText}</span>
                </Tooltip>
            );
        }
    },
    {
        title: "Add On",
        width: 120,
        render: (detail) => {
            const addOns = detail?.consultationPaymentDetails?.addOnList?.map(addonInfo => addonInfo?.addOn) || [];
            return <>{addOns?.join(", ") || "Nil"}</>;
        }
    },
    ...(activeTab === "AUTO_CANCELLED" ? [{
        title: "AutoCancelled By",
        width: 180,
        render: (_, detail) => {
            const autoCancelledBy = detail?.cancelDetails?.autoCancelledBy || detail?.cancelDetails?.autoCancelledByName;
            if (typeof autoCancelledBy === "string") {
                return <>{autoCancelledBy || "Nil"}</>;
            }
            const firstName = autoCancelledBy?.firstName || "";
            const middleName = autoCancelledBy?.middleName || "";
            const lastName = autoCancelledBy?.lastName || "";
            const fullName = `${firstName} ${middleName} ${lastName}`.trim();
            return <>{fullName || autoCancelledBy?.name || "Nil"}</>;
        }
    }] : []),
    ...(activeTab === "COMPLETED" || activeTab === "LOW_RATING" ? [{
        width: 120,
        align: "center",
        title: "Expand Time",
        render: (detail) => {
            const extendList = detail?.extendConsultionDetailsList || [];
            const totalExtendMin = extendList?.reduce((sum, extenTime) => {
                const val = Number(extenTime?.extendMin) || 0;
                return sum + val;
            }, 0);
            return <>{totalExtendMin ? `${totalExtendMin} Min` : "Nil"}</>
        }
    },
    {
        title: "Fees",
        align: "center",
        dataIndex: "fees",
        width: 100,
        render: (_, detail) => {
            return <>{detail?.consultationPaymentDetails?.totalConsultationAmount ? `₹ ${formatAmount(detail?.consultationPaymentDetails?.totalConsultationAmount)}` : "Nil"}</>
        }
    },
    {
        title: "Recording",
        align: "center",
        width: 120,
        render: (detail) => {
            const hasRecording = (detail?.consultationPaymentDetails?.recordDetail?.record ?? detail?.record) === true;
            return <>{hasRecording ? <div className="success-status"><p>Recorded</p></div> : <div className="danger-status"><p>Not Recorded</p></div>}</>
        }
    }] : []),
    ...(activeTab === "LOW_RATING" ? [{
        title: "Rating",
        align: "center",
        width: 150,
        render: (detail) => {
            return <Rate disabled allowHalf value={detail?.feedback?.rating || 0} style={{ fontSize: 14 }} />
        }
    },
    {
        title: "Reason",
        width: 200,
        render: (_, detail) => {
            const reason = detail?.feedback?.ratingReason || "Nil";
            if (reason?.length > 30) {
                return <Tooltip title={reason}>
                    <span>{reason?.slice(0, 30)}...</span>
                </Tooltip>
            }
            return <span>{reason}</span>
        }
    }] : []),
    ...(activeTab === "COMPLETED" ? [{
        title: "Complaint Status",
        width: 120,
        render: (detail) => {
            return <>{
                detail?.customerComplaintDto && detail?.customerComplaintDto?.complaintStatus === "PENDING" ? <div className="pending-status"><p>Pending</p></div>
                    : detail?.customerComplaintDto && detail?.customerComplaintDto?.complaintStatus === "COMPLETED" ? <div className="success-status"><p>Completed</p></div>
                        : detail?.lawyerComplaintDto && detail?.lawyerComplaintDto?.complaintStatus === "PENDING" ? <div className="pending-status"><p>Pending</p></div>
                            : detail?.lawyerComplaintDto && detail?.lawyerComplaintDto?.complaintStatus === "COMPLETED" ? <div className="success-status"><p>Completed</p></div> : <div>Nil</div>
            }</>
        }
    },
    {
        title: "Feedback",
        align: "center",
        width: 200,
        dataIndex: "feedback",
        render: (_, detail) => {
            const feedback = detail?.feedback?.feedback || "Nil";
            if (feedback?.length > 40) {
                return <Tooltip title={feedback}>
                    <span>{feedback?.slice(0, 40)}...</span>
                </Tooltip>
            }
            return <><span>{feedback}</span>
            </>
        }
    }] : []),
    ...(activeTab === "CANCELLED" ? [
        {
            title: "Complaint Status",
            width:120,
            render: (detail) => {
                return <>{
                    detail?.customerComplaintDto && detail?.customerComplaintDto?.complaintStatus === "PENDING" ? <div className="pending-status"><p>Pending</p></div>
                        : detail?.customerComplaintDto && detail?.customerComplaintDto?.complaintStatus === "COMPLETED" ? <div className="success-status"><p>Completed</p></div>
                            : detail?.lawyerComplaintDto && detail?.lawyerComplaintDto?.complaintStatus === "PENDING" ? <div className="pending-status"><p>Pending</p></div>
                                : detail?.lawyerComplaintDto && detail?.lawyerComplaintDto?.complaintStatus === "COMPLETED" ? <div className="success-status"><p>Completed</p></div> : <div style={{ textAlign: "center" }}>Nil</div>
                }</>
            }
        },
        {
            title: "Reason for Cancellation",
            width: 200,
            render: (_, detail) => {
                const reason = detail?.cancelDetails?.reason || "Nil";
                if (reason?.length > 30) {
                    return <Tooltip title={reason}>
                        <span>{reason?.slice(0, 30)}...</span>
                    </Tooltip>
                }
                return <><span>{reason}</span>
                </>
            }
        }
    ] : []),
    {
        title: "Action",
        width:80,
        fixed: "right",
        render: (detail) => {
            const filteredList = getConsultationDropdown(detail);
            return actionRender(detail, filteredList);
        }
    }
];

export const tabData = [
    { label: "Completed Cons.", content: "COMPLETED", key: "1" },
    { label: "Upcoming Cons.", content: "PENDING", key: "2" },
    { label: "Cancelled Cons.", content: "CANCELLED", key: "3" },
    { label: "Low Rating Cons.", content: "LOW_RATING", key: "4" },
    { label: "Auto Cancelled Cons.", content: "AUTO_CANCELLED", key: "5" }
];

export const completeConsultationDropdown = [
    { key: "view", label: "View" },
    { key: "viewComplaint", label: "View Complaints" },
    { key: "viewLawyerRasiedComplaints", label: "View Advocate Rasied Complaint" },
    { key: "viewCustiomerRasiedComplaint", label: "View Customer Rasied Complaint" },
];

export const pendingConsultationDropdown = [
    { key: "view", label: "View" },
];